frappe.ready(function() {
    var salesOrderContainer = document.getElementById('salesOrderContainer');
    if (!salesOrderContainer) {
        console.error('salesOrderContainer is null');
        return;
    }

    var salesOrderName = salesOrderContainer.getAttribute('data-sales-order-name');

    $('#updateSalesOrderButton').click(function() {
        if (!validateForm()) {
            return;
        }

        var formData = new FormData();
        formData.append('mode_of_payment', $('#mode_of_payment').val());
        formData.append('paid_amount', $('#paid_amount').val());
        formData.append('reference_no', $('#reference_no').val());
        formData.append('attachment', $('#attachment')[0].files[0]);

        frappe.call({
            method: 'campus_erp.api.sales_order.update_data_sales_order.update_sales_order',
            args: {
                sales_order_name: salesOrderName,
                mode_of_payment: $('#mode_of_payment').val(),
                paid_amount: $('#paid_amount').val(),
                reference_no: $('#reference_no').val()
            },
            callback: function(r) {
                if (r.message) {
                    frappe.msgprint("Sales Order updated successfully!");
                    uploadAttachment();
                }
            }
        });
    });

    function validateForm() {
        var isValid = true;

        if ($('#mode_of_payment').val() === '') {
            frappe.msgprint("Please select a Mode of Payment.");
            isValid = false;
        }

        if ($('#paid_amount').val().trim() === '' || isNaN($('#paid_amount').val())) {
            frappe.msgprint("Please enter a valid Paid Amount.");
            isValid = false;
        }

        if ($('#attachment')[0].files.length === 0) {
            frappe.msgprint("Please select an attachment.");
            isValid = false;
        }

        if ($('#reference_no').val().trim() === '') {
            frappe.msgprint("Please enter the UTR Number.");
            isValid = false;
        }

        return isValid;
    }

    function uploadAttachment() {
        if ($('#attachment')[0].files.length > 0) {
            var file = $('#attachment')[0].files[0];
            var reader = new FileReader();
            reader.onload = function(e) {
                frappe.call({
                    method: 'campus_erp.api.sales_order.update_data_sales_order.upload_attachment',
                    args: {
                        file_name: file.name,
                        file_data: e.target.result,
                        sales_order_name: salesOrderName
                    },
                    callback: function(r) {
                        if (r.message) {
                            frappe.msgprint("File uploaded successfully!");
                        }
                    }
                });
            };
            reader.readAsDataURL(file);
        }
    }
});